/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AuthenticationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.diamondsupport.aseaglobal.com";
    }

    authenticate(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAuthenticate(_response);
        });
    }

    protected processAuthenticate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class DiamondSupportListClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.diamondsupport.aseaglobal.com";
    }

    index(  cancelToken?: CancelToken | undefined): Promise<DsListEntryModel[]> {
        let url_ = this.baseUrl + "/api/DiamondSupportList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: AxiosResponse): Promise<DsListEntryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DsListEntryModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DsListEntryModel[]>(<any>null);
    }

    post(input: DsListEntryModel , cancelToken?: CancelToken | undefined): Promise<DsListEntryModel> {
        let url_ = this.baseUrl + "/api/DiamondSupportList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<DsListEntryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DsListEntryModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DsListEntryModel>(<any>null);
    }

    delete(distributorId: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/DiamondSupportList?";
        if (distributorId !== undefined && distributorId !== null)
            url_ += "distributorId=" + encodeURIComponent("" + distributorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class DistributorsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.diamondsupport.aseaglobal.com";
    }

    get(id: string | null , cancelToken?: CancelToken | undefined): Promise<DistributorModel> {
        let url_ = this.baseUrl + "/api/Distributors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<DistributorModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DistributorModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistributorModel>(<any>null);
    }

    search(term: string | null | undefined, page: number | undefined, pageSize: number | undefined , cancelToken?: CancelToken | undefined): Promise<DistributorModel[]> {
        let url_ = this.baseUrl + "/api/Distributors/search?";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: AxiosResponse): Promise<DistributorModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistributorModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistributorModel[]>(<any>null);
    }

    getNotes(id: string | null , cancelToken?: CancelToken | undefined): Promise<NoteModel[]> {
        let url_ = this.baseUrl + "/api/Distributors/{id}/notes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotes(_response);
        });
    }

    protected processGetNotes(response: AxiosResponse): Promise<NoteModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteModel[]>(<any>null);
    }

    getReminders(id: string | null , cancelToken?: CancelToken | undefined): Promise<ReminderModel[]> {
        let url_ = this.baseUrl + "/api/Distributors/{id}/reminders";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReminders(_response);
        });
    }

    protected processGetReminders(response: AxiosResponse): Promise<ReminderModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReminderModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderModel[]>(<any>null);
    }

    getRankHistory(id: string | null , cancelToken?: CancelToken | undefined): Promise<RankHistoryModel[]> {
        let url_ = this.baseUrl + "/api/Distributors/{id}/rankhistory";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRankHistory(_response);
        });
    }

    protected processGetRankHistory(response: AxiosResponse): Promise<RankHistoryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RankHistoryModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RankHistoryModel[]>(<any>null);
    }

    getDiamondSupportPlus(id: string | null , cancelToken?: CancelToken | undefined): Promise<ReminderModel[]> {
        let url_ = this.baseUrl + "/api/Distributors/{id}/plus";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDiamondSupportPlus(_response);
        });
    }

    protected processGetDiamondSupportPlus(response: AxiosResponse): Promise<ReminderModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReminderModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderModel[]>(<any>null);
    }

    getEnrollments(id: string | null , cancelToken?: CancelToken | undefined): Promise<DistributorModel[]> {
        let url_ = this.baseUrl + "/api/Distributors/{id}/enrollments";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEnrollments(_response);
        });
    }

    protected processGetEnrollments(response: AxiosResponse): Promise<DistributorModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistributorModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistributorModel[]>(<any>null);
    }

    getCommissions(id: string | null, rankId: string | null , cancelToken?: CancelToken | undefined): Promise<DistributorCommissionsModel[]> {
        let url_ = this.baseUrl + "/api/Distributors/{id}/{rankId}/commissions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (rankId === undefined || rankId === null)
            throw new Error("The parameter 'rankId' must be defined.");
        url_ = url_.replace("{rankId}", encodeURIComponent("" + rankId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommissions(_response);
        });
    }

    protected processGetCommissions(response: AxiosResponse): Promise<DistributorCommissionsModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DistributorCommissionsModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DistributorCommissionsModel[]>(<any>null);
    }
}

export class NotesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.diamondsupport.aseaglobal.com";
    }

    get(id: string , cancelToken?: CancelToken | undefined): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NoteModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteModel>(<any>null);
    }

    post(input: NoteModel , cancelToken?: CancelToken | undefined): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NoteModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteModel>(<any>null);
    }

    put(input: NoteModel , cancelToken?: CancelToken | undefined): Promise<NoteModel> {
        let url_ = this.baseUrl + "/api/Notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<NoteModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NoteModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteModel>(<any>null);
    }

    delete(id: string | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Notes?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class RemindersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.diamondsupport.aseaglobal.com";
    }

    getAll(  cancelToken?: CancelToken | undefined): Promise<ReminderModel[]> {
        let url_ = this.baseUrl + "/api/Reminders/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ReminderModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReminderModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderModel[]>(<any>null);
    }

    get(id: string , cancelToken?: CancelToken | undefined): Promise<ReminderModel> {
        let url_ = this.baseUrl + "/api/Reminders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ReminderModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReminderModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderModel>(<any>null);
    }

    post(input: ReminderModel , cancelToken?: CancelToken | undefined): Promise<ReminderModel> {
        let url_ = this.baseUrl + "/api/Reminders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<ReminderModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReminderModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderModel>(<any>null);
    }

    put(input: ReminderModel , cancelToken?: CancelToken | undefined): Promise<ReminderModel> {
        let url_ = this.baseUrl + "/api/Reminders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<ReminderModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReminderModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderModel>(<any>null);
    }

    delete(model: ReminderModel , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Reminders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class UsersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://api.diamondsupport.aseaglobal.com";
    }

    getNotes(id: string | null , cancelToken?: CancelToken | undefined): Promise<NoteModel[]> {
        let url_ = this.baseUrl + "/notes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNotes(_response);
        });
    }

    protected processGetNotes(response: AxiosResponse): Promise<NoteModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NoteModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NoteModel[]>(<any>null);
    }

    getReminders(id: string | null , cancelToken?: CancelToken | undefined): Promise<ReminderModel[]> {
        let url_ = this.baseUrl + "/reminders/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReminders(_response);
        });
    }

    protected processGetReminders(response: AxiosResponse): Promise<ReminderModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReminderModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReminderModel[]>(<any>null);
    }
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; } | undefined;
}

export class DsListEntryModel implements IDsListEntryModel {
    id?: string;
    userId?: string | undefined;
    distributorId?: string | undefined;
    fullName?: string | undefined;
    businessName?: string | undefined;
    mobilePhone?: string | undefined;
    secondPhone?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    lastPaidRank?: string | undefined;
    lifetimeRank?: string | undefined;
    enrollmentDate?: string | undefined;
    isSpaData?: boolean;
    renewalDate?: string | undefined;
    createdUtc?: Date;
    createdBy?: string | undefined;
    updatedUtc?: Date;
    updatedBy?: string | undefined;
    deletedUtc?: Date | undefined;

    constructor(data?: IDsListEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.distributorId = _data["distributorId"];
            this.fullName = _data["fullName"];
            this.businessName = _data["businessName"];
            this.mobilePhone = _data["mobilePhone"];
            this.secondPhone = _data["secondPhone"];
            this.email = _data["email"];
            this.country = _data["country"];
            this.lastPaidRank = _data["lastPaidRank"];
            this.lifetimeRank = _data["lifetimeRank"];
            this.enrollmentDate = _data["enrollmentDate"];
            this.isSpaData = _data["isSpaData"];
            this.renewalDate = _data["renewalDate"];
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedUtc = _data["updatedUtc"] ? new Date(_data["updatedUtc"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.deletedUtc = _data["deletedUtc"] ? new Date(_data["deletedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DsListEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new DsListEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["distributorId"] = this.distributorId;
        data["fullName"] = this.fullName;
        data["businessName"] = this.businessName;
        data["mobilePhone"] = this.mobilePhone;
        data["secondPhone"] = this.secondPhone;
        data["email"] = this.email;
        data["country"] = this.country;
        data["lastPaidRank"] = this.lastPaidRank;
        data["lifetimeRank"] = this.lifetimeRank;
        data["enrollmentDate"] = this.enrollmentDate;
        data["isSpaData"] = this.isSpaData;
        data["renewalDate"] = this.renewalDate;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedUtc"] = this.updatedUtc ? this.updatedUtc.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["deletedUtc"] = this.deletedUtc ? this.deletedUtc.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IDsListEntryModel {
    id?: string;
    userId?: string | undefined;
    distributorId?: string | undefined;
    fullName?: string | undefined;
    businessName?: string | undefined;
    mobilePhone?: string | undefined;
    secondPhone?: string | undefined;
    email?: string | undefined;
    country?: string | undefined;
    lastPaidRank?: string | undefined;
    lifetimeRank?: string | undefined;
    enrollmentDate?: string | undefined;
    isSpaData?: boolean;
    renewalDate?: string | undefined;
    createdUtc?: Date;
    createdBy?: string | undefined;
    updatedUtc?: Date;
    updatedBy?: string | undefined;
    deletedUtc?: Date | undefined;
}

export class DistributorModel implements IDistributorModel {
    distributorId?: string | undefined;
    fullName?: string | undefined;
    coApplicantFullName?: string | undefined;
    businessName?: string | undefined;
    fullAddress?: string | undefined;
    mobilePhone?: string | undefined;
    secondPhone?: string | undefined;
    email?: string | undefined;
    sponsorFullName?: string | undefined;
    sponsorDistributorId?: string | undefined;
    sponsorEmail?: string | undefined;
    sponsorPhone?: string | undefined;
    associateStatus?: string | undefined;
    lastPaidRank?: string | undefined;
    lifetimeRank?: string | undefined;
    enrollmentDate?: string | undefined;
    renewalDate?: string | undefined;
    personalEnrollmentCount?: number;

    constructor(data?: IDistributorModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.distributorId = _data["distributorId"];
            this.fullName = _data["fullName"];
            this.coApplicantFullName = _data["coApplicantFullName"];
            this.businessName = _data["businessName"];
            this.fullAddress = _data["fullAddress"];
            this.mobilePhone = _data["mobilePhone"];
            this.secondPhone = _data["secondPhone"];
            this.email = _data["email"];
            this.sponsorFullName = _data["sponsorFullName"];
            this.sponsorDistributorId = _data["sponsorDistributorId"];
            this.sponsorEmail = _data["sponsorEmail"];
            this.sponsorPhone = _data["sponsorPhone"];
            this.associateStatus = _data["associateStatus"];
            this.lastPaidRank = _data["lastPaidRank"];
            this.lifetimeRank = _data["lifetimeRank"];
            this.enrollmentDate = _data["enrollmentDate"];
            this.renewalDate = _data["renewalDate"];
            this.personalEnrollmentCount = _data["personalEnrollmentCount"];
        }
    }

    static fromJS(data: any): DistributorModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistributorModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["distributorId"] = this.distributorId;
        data["fullName"] = this.fullName;
        data["coApplicantFullName"] = this.coApplicantFullName;
        data["businessName"] = this.businessName;
        data["fullAddress"] = this.fullAddress;
        data["mobilePhone"] = this.mobilePhone;
        data["secondPhone"] = this.secondPhone;
        data["email"] = this.email;
        data["sponsorFullName"] = this.sponsorFullName;
        data["sponsorDistributorId"] = this.sponsorDistributorId;
        data["sponsorEmail"] = this.sponsorEmail;
        data["sponsorPhone"] = this.sponsorPhone;
        data["associateStatus"] = this.associateStatus;
        data["lastPaidRank"] = this.lastPaidRank;
        data["lifetimeRank"] = this.lifetimeRank;
        data["enrollmentDate"] = this.enrollmentDate;
        data["renewalDate"] = this.renewalDate;
        data["personalEnrollmentCount"] = this.personalEnrollmentCount;
        return data; 
    }
}

export interface IDistributorModel {
    distributorId?: string | undefined;
    fullName?: string | undefined;
    coApplicantFullName?: string | undefined;
    businessName?: string | undefined;
    fullAddress?: string | undefined;
    mobilePhone?: string | undefined;
    secondPhone?: string | undefined;
    email?: string | undefined;
    sponsorFullName?: string | undefined;
    sponsorDistributorId?: string | undefined;
    sponsorEmail?: string | undefined;
    sponsorPhone?: string | undefined;
    associateStatus?: string | undefined;
    lastPaidRank?: string | undefined;
    lifetimeRank?: string | undefined;
    enrollmentDate?: string | undefined;
    renewalDate?: string | undefined;
    personalEnrollmentCount?: number;
}

export class NoteModel implements INoteModel {
    id?: string;
    distributorId?: string | undefined;
    userId?: string | undefined;
    content?: string | undefined;
    isCritical?: boolean;
    createdUtc?: Date;
    createdBy?: string | undefined;
    updatedUtc?: Date;
    updatedBy?: string | undefined;
    deletedUtc?: Date | undefined;

    constructor(data?: INoteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.distributorId = _data["distributorId"];
            this.userId = _data["userId"];
            this.content = _data["content"];
            this.isCritical = _data["isCritical"];
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedUtc = _data["updatedUtc"] ? new Date(_data["updatedUtc"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.deletedUtc = _data["deletedUtc"] ? new Date(_data["deletedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): NoteModel {
        data = typeof data === 'object' ? data : {};
        let result = new NoteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["distributorId"] = this.distributorId;
        data["userId"] = this.userId;
        data["content"] = this.content;
        data["isCritical"] = this.isCritical;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedUtc"] = this.updatedUtc ? this.updatedUtc.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["deletedUtc"] = this.deletedUtc ? this.deletedUtc.toISOString() : <any>undefined;
        return data; 
    }
}

export interface INoteModel {
    id?: string;
    distributorId?: string | undefined;
    userId?: string | undefined;
    content?: string | undefined;
    isCritical?: boolean;
    createdUtc?: Date;
    createdBy?: string | undefined;
    updatedUtc?: Date;
    updatedBy?: string | undefined;
    deletedUtc?: Date | undefined;
}

export class ReminderModel implements IReminderModel {
    id?: string;
    distributorId?: string | undefined;
    content?: string | undefined;
    dueOnUtc?: Date;
    isUrgent?: boolean;
    completedOnUtc?: Date | undefined;
    createdUtc?: Date;
    createdBy?: string | undefined;
    updatedUtc?: Date;
    updatedBy?: string | undefined;
    deletedUtc?: Date | undefined;

    constructor(data?: IReminderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.distributorId = _data["distributorId"];
            this.content = _data["content"];
            this.dueOnUtc = _data["dueOnUtc"] ? new Date(_data["dueOnUtc"].toString()) : <any>undefined;
            this.isUrgent = _data["isUrgent"];
            this.completedOnUtc = _data["completedOnUtc"] ? new Date(_data["completedOnUtc"].toString()) : <any>undefined;
            this.createdUtc = _data["createdUtc"] ? new Date(_data["createdUtc"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedUtc = _data["updatedUtc"] ? new Date(_data["updatedUtc"].toString()) : <any>undefined;
            this.updatedBy = _data["updatedBy"];
            this.deletedUtc = _data["deletedUtc"] ? new Date(_data["deletedUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReminderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReminderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["distributorId"] = this.distributorId;
        data["content"] = this.content;
        data["dueOnUtc"] = this.dueOnUtc ? this.dueOnUtc.toISOString() : <any>undefined;
        data["isUrgent"] = this.isUrgent;
        data["completedOnUtc"] = this.completedOnUtc ? this.completedOnUtc.toISOString() : <any>undefined;
        data["createdUtc"] = this.createdUtc ? this.createdUtc.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedUtc"] = this.updatedUtc ? this.updatedUtc.toISOString() : <any>undefined;
        data["updatedBy"] = this.updatedBy;
        data["deletedUtc"] = this.deletedUtc ? this.deletedUtc.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IReminderModel {
    id?: string;
    distributorId?: string | undefined;
    content?: string | undefined;
    dueOnUtc?: Date;
    isUrgent?: boolean;
    completedOnUtc?: Date | undefined;
    createdUtc?: Date;
    createdBy?: string | undefined;
    updatedUtc?: Date;
    updatedBy?: string | undefined;
    deletedUtc?: Date | undefined;
}

export class RankHistoryModel implements IRankHistoryModel {
    rankNumber?: number;
    rankName?: string | undefined;
    rankDate?: string | undefined;

    constructor(data?: IRankHistoryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rankNumber = _data["rankNumber"];
            this.rankName = _data["rankName"];
            this.rankDate = _data["rankDate"];
        }
    }

    static fromJS(data: any): RankHistoryModel {
        data = typeof data === 'object' ? data : {};
        let result = new RankHistoryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankNumber"] = this.rankNumber;
        data["rankName"] = this.rankName;
        data["rankDate"] = this.rankDate;
        return data; 
    }
}

export interface IRankHistoryModel {
    rankNumber?: number;
    rankName?: string | undefined;
    rankDate?: string | undefined;
}

export class DistributorCommissionsModel implements IDistributorCommissionsModel {
    rankName?: string | undefined;
    lifetimmeRankId?: number;
    activeTotalPv?: number;
    personalVolume?: number;
    personalLeftEnrollees?: number;
    personalRightEnrollees?: number;
    director300Legs?: number;
    director300LegsRequirement?: number;
    totalBinaryLesserVolume?: number;
    totalBinaryLesserVolumeRequirement?: number;
    twoWeekLesserLegTotal?: number;
    twoWeekLesserRequirement?: number;
    threeWeekLesserLegTotal?: number;
    threeWeekLesserRequirement?: number;
    threeWeekTotalPgv50?: number;
    threeWeekTotalPgv50Requirement?: number;
    consecutiveWeeksMaintainingVolume?: number;
    consecutiveWeeksMaintainingVolumeRequirement?: number;
    weekPgv?: number;
    requiredWeekPgv?: number;
    weekGv?: number;
    requiredWeekGv?: number;
    period?: string | undefined;
    commPeriodId?: number;
    pvDate?: string | undefined;
    paidRank?: string | undefined;
    paidRankId?: number;
    pv?: number;
    periodLv?: number;
    carryoverLv?: number;
    totalLv?: number;
    periodRv?: number;
    carryoverRv?: number;
    totalRv?: number;
    pgv?: number;
    pgv3?: number;
    directOf300?: number;
    pgv50?: number;
    ambassadorPgv?: number;

    constructor(data?: IDistributorCommissionsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rankName = _data["rankName"];
            this.lifetimmeRankId = _data["lifetimmeRankId"];
            this.activeTotalPv = _data["activeTotalPv"];
            this.personalVolume = _data["personalVolume"];
            this.personalLeftEnrollees = _data["personalLeftEnrollees"];
            this.personalRightEnrollees = _data["personalRightEnrollees"];
            this.director300Legs = _data["director300Legs"];
            this.director300LegsRequirement = _data["director300LegsRequirement"];
            this.totalBinaryLesserVolume = _data["totalBinaryLesserVolume"];
            this.totalBinaryLesserVolumeRequirement = _data["totalBinaryLesserVolumeRequirement"];
            this.twoWeekLesserLegTotal = _data["twoWeekLesserLegTotal"];
            this.twoWeekLesserRequirement = _data["twoWeekLesserRequirement"];
            this.threeWeekLesserLegTotal = _data["threeWeekLesserLegTotal"];
            this.threeWeekLesserRequirement = _data["threeWeekLesserRequirement"];
            this.threeWeekTotalPgv50 = _data["threeWeekTotalPgv50"];
            this.threeWeekTotalPgv50Requirement = _data["threeWeekTotalPgv50Requirement"];
            this.consecutiveWeeksMaintainingVolume = _data["consecutiveWeeksMaintainingVolume"];
            this.consecutiveWeeksMaintainingVolumeRequirement = _data["consecutiveWeeksMaintainingVolumeRequirement"];
            this.weekPgv = _data["weekPgv"];
            this.requiredWeekPgv = _data["requiredWeekPgv"];
            this.weekGv = _data["weekGv"];
            this.requiredWeekGv = _data["requiredWeekGv"];
            this.period = _data["period"];
            this.commPeriodId = _data["commPeriodId"];
            this.pvDate = _data["pvDate"];
            this.paidRank = _data["paidRank"];
            this.paidRankId = _data["paidRankId"];
            this.pv = _data["pv"];
            this.periodLv = _data["periodLv"];
            this.carryoverLv = _data["carryoverLv"];
            this.totalLv = _data["totalLv"];
            this.periodRv = _data["periodRv"];
            this.carryoverRv = _data["carryoverRv"];
            this.totalRv = _data["totalRv"];
            this.pgv = _data["pgv"];
            this.pgv3 = _data["pgv3"];
            this.directOf300 = _data["directOf300"];
            this.pgv50 = _data["pgv50"];
            this.ambassadorPgv = _data["ambassadorPgv"];
        }
    }

    static fromJS(data: any): DistributorCommissionsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DistributorCommissionsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rankName"] = this.rankName;
        data["lifetimmeRankId"] = this.lifetimmeRankId;
        data["activeTotalPv"] = this.activeTotalPv;
        data["personalVolume"] = this.personalVolume;
        data["personalLeftEnrollees"] = this.personalLeftEnrollees;
        data["personalRightEnrollees"] = this.personalRightEnrollees;
        data["director300Legs"] = this.director300Legs;
        data["director300LegsRequirement"] = this.director300LegsRequirement;
        data["totalBinaryLesserVolume"] = this.totalBinaryLesserVolume;
        data["totalBinaryLesserVolumeRequirement"] = this.totalBinaryLesserVolumeRequirement;
        data["twoWeekLesserLegTotal"] = this.twoWeekLesserLegTotal;
        data["twoWeekLesserRequirement"] = this.twoWeekLesserRequirement;
        data["threeWeekLesserLegTotal"] = this.threeWeekLesserLegTotal;
        data["threeWeekLesserRequirement"] = this.threeWeekLesserRequirement;
        data["threeWeekTotalPgv50"] = this.threeWeekTotalPgv50;
        data["threeWeekTotalPgv50Requirement"] = this.threeWeekTotalPgv50Requirement;
        data["consecutiveWeeksMaintainingVolume"] = this.consecutiveWeeksMaintainingVolume;
        data["consecutiveWeeksMaintainingVolumeRequirement"] = this.consecutiveWeeksMaintainingVolumeRequirement;
        data["weekPgv"] = this.weekPgv;
        data["requiredWeekPgv"] = this.requiredWeekPgv;
        data["weekGv"] = this.weekGv;
        data["requiredWeekGv"] = this.requiredWeekGv;
        data["period"] = this.period;
        data["commPeriodId"] = this.commPeriodId;
        data["pvDate"] = this.pvDate;
        data["paidRank"] = this.paidRank;
        data["paidRankId"] = this.paidRankId;
        data["pv"] = this.pv;
        data["periodLv"] = this.periodLv;
        data["carryoverLv"] = this.carryoverLv;
        data["totalLv"] = this.totalLv;
        data["periodRv"] = this.periodRv;
        data["carryoverRv"] = this.carryoverRv;
        data["totalRv"] = this.totalRv;
        data["pgv"] = this.pgv;
        data["pgv3"] = this.pgv3;
        data["directOf300"] = this.directOf300;
        data["pgv50"] = this.pgv50;
        data["ambassadorPgv"] = this.ambassadorPgv;
        return data; 
    }
}

export interface IDistributorCommissionsModel {
    rankName?: string | undefined;
    lifetimmeRankId?: number;
    activeTotalPv?: number;
    personalVolume?: number;
    personalLeftEnrollees?: number;
    personalRightEnrollees?: number;
    director300Legs?: number;
    director300LegsRequirement?: number;
    totalBinaryLesserVolume?: number;
    totalBinaryLesserVolumeRequirement?: number;
    twoWeekLesserLegTotal?: number;
    twoWeekLesserRequirement?: number;
    threeWeekLesserLegTotal?: number;
    threeWeekLesserRequirement?: number;
    threeWeekTotalPgv50?: number;
    threeWeekTotalPgv50Requirement?: number;
    consecutiveWeeksMaintainingVolume?: number;
    consecutiveWeeksMaintainingVolumeRequirement?: number;
    weekPgv?: number;
    requiredWeekPgv?: number;
    weekGv?: number;
    requiredWeekGv?: number;
    period?: string | undefined;
    commPeriodId?: number;
    pvDate?: string | undefined;
    paidRank?: string | undefined;
    paidRankId?: number;
    pv?: number;
    periodLv?: number;
    carryoverLv?: number;
    totalLv?: number;
    periodRv?: number;
    carryoverRv?: number;
    totalRv?: number;
    pgv?: number;
    pgv3?: number;
    directOf300?: number;
    pgv50?: number;
    ambassadorPgv?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}